<template>
  <div class="header ">
    <div class="l">
      <div class="logo"><img src="../assets/icon_logo.png" alt=""></div>
      <div class="h1"><span>湛江仲裁委员会</span></div>
      <div class="title"><span>{{ title }}</span></div>
      <div><router-link to="/">返回首页</router-link></div>
    </div>
    <div class="r">
      <span> 法律文书模板 </span>
      <span> 帮助指引 </span>
      <router-link to="/"><img src="../assets/icon_msg.png" alt="">消息通知 </router-link>
      <span> <img src="../assets/icon_check_user.png" alt=""> 欢迎您，{{ userInfo.userName }} </span>
      <span class="click" @click="_exit"> <img src="../assets/icon_check_exit.png" alt=""> 退出账户 </span>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  props: {
    title: {
      default: '个人中心'
    }
  },
  data () {
    return {
      exitStatus: true
    }
  },
  computed: mapState(['userInfo']),
  methods: {
    _exit () {
      const _this = this
      if (_this.exitStatus) {
        _this.exitStatus = false
        window.localStorage.clear()
        _this.$store.commit('SET_USER_INFO', {})
        _this.$message.success('退出登录').then(() => {
          _this.$router.go(-1)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.header {
  height: 0.75rem;
  line-height: 0.75rem;
  padding: 0 0.333rem;
  background-color: #fff;
  border-bottom: 1px solid #E7E7E7;
  display: flex;
  .r {
    flex: 1;
    text-align: right;
    span:last-child {
      padding-right: 0;
    }
    a, span {
      font-size: 0.167rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      padding-left: 0.325rem;
      padding-right: 0.233rem;
      position: relative;
      &::after {
        position: absolute;
        content: ' ';
        width: 0.008rem;
        top: 0;
        bottom: 0;
        left: 0;
        background-color: #333333;
        border-radius: 0.004rem;
      }
      img {
        width: 0.167rem;
        height: 0.167rem;
        margin-bottom: 0.02rem;
        margin-right: 0.1rem;
      }
    }
  }
  .l {
    display: flex;
    .title {
      span {
        font-size: 0.167rem;
        color: #333333;
        margin-left: 0.325rem;
        font-family: PingFang SC;
        font-weight: bold;
      }
    }
    a {
      font-size: 0.167rem;
      color: #3B97E5;
      margin-left: 0.333rem;
      font-family: PingFang SC;
      font-weight: bold;
    }
    .h1 {
      span {
        font-size: 0.3rem;
        margin-left: 0.092rem;
        color: #333333;
        font-family: PingFang SC;
        font-weight: bold;
      }
    }
    .logo {
      img {
        width: 0.558rem;
        height: 0.558rem;
      }
    }
  }
}
</style>
